import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AdvancedTransactionTypes from "const/AdvancedTransactionTypes";
import IntegrationServices from "const/IntegrationServices";
import MultiSelect from "nlib/ui/MultiSelect";
import React, { useMemo } from "react";
import TransactionTypes from "const/TransactionTypes";

const TypeInput = ({ value, ...restProps }) => {
  const { uiTexts } = useSelector(getTextsData);

  const { extraData: { integrationService } = {} } = useSelector(getSelectedBusinessData);

  const typeList = useMemo(() => {
    switch (integrationService) {
      case IntegrationServices.XERO.value: {
        return [
          { value: TransactionTypes.WITHDRAW, label: AdvancedTransactionTypes.SPENT },
          { value: TransactionTypes.DEPOSIT, label: AdvancedTransactionTypes.RECEIVED }
        ];
      }
      case IntegrationServices.ZOHO.value: {
        return [
          { value: TransactionTypes.WITHDRAW, label: AdvancedTransactionTypes.EXPENSE },
          { value: TransactionTypes.DEPOSIT, label: TransactionTypes.DEPOSIT }
        ];
      }
      default: {
        return [
          { value: TransactionTypes.DEPOSIT, label: AdvancedTransactionTypes.INCOME },
          { value: TransactionTypes.WITHDRAW, label: AdvancedTransactionTypes.EXPENSE }
        ];
      }
    }
  }, [integrationService]);

  const items = useMemo(() => {
    return typeList
      .map(({ value: val, label }) => ({ value: val, label: uiTexts[label] }))
      .sort(({ label: nameA }, { label: nameB }) => nameA.localeCompare(nameB));
  }, [typeList, uiTexts]);

  return (
    <MultiSelect
      value={value}
      invalid={!value.length}
      placeholder={uiTexts.selectType}
      options={items}
      {...restProps} />
  );
};

export default React.memo(TypeInput);
